import { Link } from 'react-router-dom';
import { Sparkles, X } from 'lucide-react';
import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import ClaimProfileBanner from './ClaimProfileBanner';

const OnboardingBanner = () => {
  const { user, employeeProfile, isLoading } = useAuth();
  const [dismissed, setDismissed] = useState(false);

  if (isLoading || !user || dismissed) return null;

  // No linked profile: ClaimProfileBanner handles match suggestion, browse, and create paths
  if (!employeeProfile) {
    return <ClaimProfileBanner />;
  }

  // Profile exists but is incomplete
  if (!employeeProfile.profile_complete) {
    return (
      <div className="bg-primary-600/10 border-b border-primary-600/25">
        <div className="container-custom py-2.5 flex items-center gap-3">
          <Sparkles className="h-3.5 w-3.5 text-primary-400 flex-shrink-0" />
          <p className="text-xs text-primary-300 flex-1">
            Your profile isn&apos;t complete yet —{' '}
            <Link to="/profile/edit" className="underline hover:text-primary-200 font-medium">
              finish setting it up
            </Link>{' '}
            to appear on the team map.
          </p>
          <button
            onClick={() => setDismissed(true)}
            className="text-primary-400/60 hover:text-primary-300 transition-colors flex-shrink-0"
            aria-label="Dismiss"
          >
            <X className="h-3.5 w-3.5" />
          </button>
        </div>
      </div>
    );
  }

  return null;
};

export default OnboardingBanner;
